module.exports = __webpack_public_path__ + "media/images/icons/material/link-7e2be32ceff02a360a121437dfa7d349.svg";